import EditComponent from '../manage-login-sms-notification-edit/component';
import template from './template.html';

export default class ViewComponent extends EditComponent {
  constructor() {
    super();
    this.template = template;
  }
}



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-login-sms-notification/components/manage-login-sms-notification-view/component.js